import script from "./SgsReportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SgsReportPage.vue?vue&type=script&setup=true&lang=js"

import "./SgsReportPage.vue?vue&type=style&index=0&id=7ec498b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec498b6"]])

export default __exports__